import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import PageHeader from './components/PageHeader.vue'
import PageFooter from './components/PageFooter.vue'
import PageFooter1 from './components/PageFooter1.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ba from 'vue-ba'
import store from './store'
import ElementUI from 'element-ui';

import Meta from 'vue-meta'

import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/dist/css/swiper.css'
// import SocketIO from 'socket.io-client';
// import VueSocketIO from 'vue-socket.io';
const Table = ElementUI.Table
const TableColumn = ElementUI.TableColumn
const Input = ElementUI.Input
const Button = ElementUI.Button
const Col = ElementUI.Col
const Row = ElementUI.Row
const Popover = ElementUI.Popover
const Pagination = ElementUI.Pagination

// const Table TableColumn Input,Button,Col,Row,Popover,Pagination from 'element-ui';
// require styles


Vue.use(ElementUI);

Vue.use(Meta);
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(VueAxios, axios)
Vue.prototype.VueAxios = axios;
Vue.use(router)
Vue.component("pageheader",PageHeader);
Vue.component("pagefooter",PageFooter);
Vue.component("pagefooter1",PageFooter1);
Vue.use(ba, "e95ceb1c590802e90ac88db80a59c6d3");
Vue.use(ba, { siteId: "e95ceb1c590802e90ac88db80a59c6d3" });
// Vue.use(new VueSocketIO({
// 	debug: true,
// 	connection: SocketIO('http://api.id-photo-verify.com',{
// 		path:'/api/V2/socket'
// 	}), //xxx填后台给的socket地址，端口号根据实际后台端口写
//
// }))
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Input);
Vue.use(Button);
Vue.use(Col);
Vue.use(Row);
Vue.use(Popover);
Vue.use(Pagination);

new Vue({
	router,
	store,
	render: h => h(App),
	mounted () {
		document.dispatchEvent(new Event('render-event'))
	}
}).$mount('#app')
